export default {"src":"/org/_next/static/media/logo.b359faaf.svg","height":22,"width":111,"blurWidth":0,"blurHeight":0};